import { createRef, useRef, useState } from "react";

export const useFocus = () => {
  const ctrlRefs = useRef([]);

  const setFocus = (key) => {
    ctrlRefs.current[key] && ctrlRefs.current[key].instance.focus();
  };

  return [ctrlRefs, setFocus];
};

export const useFocus2 = (numberOfInputs) => {
  const [inputRefs] = useState(Array.from({ length: numberOfInputs }, () => createRef()));

  const setFocus = (inputNumber) => {
    if (!inputRefs[inputNumber]?.current) {
      return;
    }

    inputRefs[inputNumber].current.instance.focus();
  };

  const checkIfCanGetFocus = (item) => {
    if (!item?.props) {
      return false;
    }

    if (!item.props.hasOwnProperty("disabled") && !item.props.hasOwnProperty("visible")) {
      return true;
    }

    if ((item.props.hasOwnProperty("visible") && !item.props.visible) || (item.props.hasOwnProperty("disabled") && item.props.disabled)) {
      return false;
    }

    return true;
  };

  const moveNext = (inputNumber) => {
    let nextInput;

    for (let i = inputNumber; i < numberOfInputs; i++) {
      const next = inputRefs[i + 1]?.current;
      const canGetFocus = checkIfCanGetFocus(next);

      if (canGetFocus) {
        nextInput = next;
        break;
      }

      if (i === numberOfInputs - 1) {
        i = 0;
      }
    }

    nextInput?.instance.focus();
  };

  return [inputRefs, setFocus, moveNext];
};
